import { Sidebar } from '../../../../../components/sidebar/Sidebar';
import styles from '../addServiceRequest.module.css';

import React, { useEffect, useState } from "react";
import { Formik, Field, Form, useField } from 'formik';
import {
  FormFieldLabel as Label,
  FormErrorLabel as ErrorLabel,
} from "../../../../../components/label/Labels";
import { FormTextArea,TextInput } from "../../../../../components/input/inputs";
import * as Yup from "yup";
import { Submit, BackButton } from "../../../../../components/button/buttons";
import FileAttachment from "../../../fileAttachment/fileAttachment.container"
import { DetailContainer } from "../../../../../components/comment/comment";
import Asterisk from "../../../../../components/asterisk/Asterisk";
import IMAGES from "../../../../../assets/images/images";
import * as DOMPurify from 'dompurify';
import Tooltip from '../../../../../components/toolTip/toolTip';
import { connect } from "react-redux";
import { openAlertPopup } from "../../../../../redux/actions/Alert/alert.action";
import { SubmitService } from "../../../../../redux/actions/incidentManagement/raiseServiceRequest.action";
import { getServiceList } from "../../../../../redux/actions/incidentManagement/serviceList.action";
import { FromLabel, Incident_Service_Type_Values, MAX_FILES, MY_INCIDENT_TABS, SERVICE_REQUEST_TYPES_VALUES, TOOLTIPS } from '../../../../../utils/constants/incidentConstants';
import { setIncidentActiveTab } from '../../../../../redux/actions/incidentManagement/incidentTab.action';
import { USER_TYPE } from '../../../../../utils/constants/userConstants';
import { OneITSMIndicator } from '../../../myIncidents/controllers/controllers';
import { showErrorPopup } from '../../../../../redux/actions/customErrorPopup/customerrorpopup.action';
import { useNavigate } from 'react-router-dom';
import { getModuleNotification } from '../../../../../redux/actions/notification/getModuleNotification.action';
import { renderTooltipList } from '../../../../../utils/utils';
import MultipleEmailInput from '../../../../../components/multipleEmailInput/MultipleEmailInput';
const IVC =(props) => {

    const [isSubmit, setIsSubmit] = useState(false);
    const navigate = useNavigate();
     
   const FieldWrapper = ({ children }) => {
     return <div  className={styles.fieldWrapper}>{children}</div>;
   };
   const ButtonWrapper = ({ children }) => {
     return <div className={styles.buttonContainer}>{children}</div>;
   };
   
   const TextField = ({ label, placeholder,maxlength, ...props }) => {
     const [field, meta, helpers] = useField(props);
     const hasError = meta.touched && meta.error ? true : false;
     const inputStyle = hasError
     ? styles.inputError
     : null;
     return (
       <FieldWrapper>
         <div>
           <Label text={label} style={styles.labelcompLevel}/>
           <Asterisk /><span className={styles.circlered}>
           {props.tooltiprquired == "true"? <span className={styles.tooltip} ><Tooltip text={props.tooltiptxt}/></span>:<></>}
            </span>
         </div>
         <TextInput {...field} {...props} placeholder={placeholder} style={styles.additionalStyle} />
          <div style={{display:"flex", justifyContent: hasError?"space-between":"flex-end"}}>
             {hasError ? <ErrorLabel text={meta.error} /> : null}
             {maxlength ?? <label >{maxlength}</label>}
          </div>
       </FieldWrapper>
     );
   };
   
   const TextArea = ({ label, optional = false,maxlength, ...props }) => {
     const [field, meta, helpers] = useField(props);
     const hasError = meta.touched && meta.error ? true : false;
     const inputStyle = hasError
       ? `${styles.input} ${styles.inputError}`
       : styles.input;
     return (
       <FieldWrapper>
         <div className={styles.labelcomment}>
         <Label text={label} optional={optional} style={styles.labelcompLevel}/>{props.name === "problemStatement" ?<Asterisk />:<></>}
         <span className={styles.circlered}>
           {props.tooltiprquired == "true"? <span className={styles.tooltip} ><Tooltip text={props.tooltiptxt}/></span>:<></>}
            </span>
         </div>      
         <FormTextArea {...field} {...props} style={styles.additionalStyle} />
         <div style={{display:"flex", justifyContent: hasError?"space-between":"flex-end"}}>
         {hasError ? <ErrorLabel text={meta.error} /> : null}
          {maxlength ?? <label >{maxlength}</label>}
         </div>
       </FieldWrapper>
     );
   };
   
   const ImageUpload = ({
     setFieldValue,
     value,
     label = "Supporting Attachments",
     ...props
   }) => {
     const [field, meta, helpers] = useField(props);
     const hasError = meta.touched && meta.error ? true : false;
     return (
       <FieldWrapper >
        <div>
         <Label text={label} optional={false} style={styles.labelcompLevel}/> <span className={styles.circlered}>
           {props.tooltiprquired == "true"? <span className={styles.tooltip} ><Tooltip text={props.tooltiptxt}/></span>:<></>}
            </span></div>
         <FileAttachment name={props.name} value={value} setFieldValue={setFieldValue} />
         {hasError ? <ErrorLabel text={meta.error} /> : null}
       </FieldWrapper>
     );
   };
   let _initialValues = {
     issue: "",
     servicesImpacted:null,
     SingleMultiple:null,
     problemStatement: "",
     additionalEmails:[],
     files: [],
   
   };
   // oneitsm_api_integration: Validation interim MAX_FILES: 15 file and OneITSM MAX_FILES:1 file
   const validationSchema = Yup.object({
    issue: Yup.string().max(100,"Title must be at most 100 characters").required("Required"), 
    problemStatement: Yup.string().max(1000,"Problem statement must be at most 1000 characters").required("Required"),
    additionalEmails: Yup.array().of(Yup.string().trim().email("Please enter a valid email address.")),
    files:Yup.array().max(MAX_FILES)
   });
   
   const ivcCustomerData = props?.myRights?.customerUserMetaInfo?.myServices?.find(item => item.serviceType?.value === Incident_Service_Type_Values?.IVC_Service);
   return (
    
     <Formik
       initialValues={_initialValues}
       enableReinitialize={true}
       validationSchema={validationSchema}
       validateOnChange
       onSubmit={async (values, { resetForm }) => {   
        setIsSubmit(true);
         let obj = {
          serviceRequestType: props.selectedForm,
          servicesImpacted:values.servicesImpacted, 
          singleOrmultipleMsisdn:values.SingleMultiple,
          uniqueCustomerRefId:props.myRights?.customerUserMetaInfo?.uniqueCustomerRefId,
          serviceRequestDetails: {
               title:values.issue,    
               problemStatement:values.problemStatement,
               additionalEmails:values.additionalEmails,
               attachement:values.files
          },
      };
         props.addService(obj).then((result) => {          
           if (result.status) {
            
             props.openAlertPopup({
               message: `A new service request with ID: ${result?.res?.data?.ticketIdServiceDesk} has been created.`,
               image: IMAGES.success
             });
             if(props.incidentActiveTab===MY_INCIDENT_TABS.MY_INCIDENTS){
              props.setIncidentActiveTab(MY_INCIDENT_TABS.MY_SERVICE_REQUEST);
              navigate("/incident-management/serviceRequests")
            }
             setIsSubmit(false);            
             resetForm();   
              props.onClose();
              props.getServiceList();
              props.getModuleNotification();
           } else {
            if(result.code === 500){
              const errormsg = <div>Service temporarily unavailable. Please try again later.<div style={{marginTop:'10px'}}>If the issue persists while using the portal, you may report it via email at cscvcs@vodafone.com with relevant details. </div></div>
              props.showErrorPopup({errorHeader:"Service Unavailable"},{errorMessage:errormsg},{isnote:true });
              setIsSubmit(false); 
              }else{
            let error_msg = result?.error;
             props.openAlertPopup({
               message: error_msg,
               image: IMAGES.error,
               isFormOpen:true
             });
            }
             setIsSubmit(false); 
           //  props.onClose();  
           }
         })
           .catch((error) => {
          
             props.openAlertPopup({
               message: "An error occurred while processing your request. Please try again later.",
               image: IMAGES.error,
               isFormOpen:true
             });
             setIsSubmit(false);     
       //      props.onClose();     
           });
   
       }}
     >
       {({ isValid,values,dirty, setFieldValue, resetForm }) => (  
        <>     
         <Form 
         id="ivc_service_request"
         className={styles.form}>          
            {props.selectedForm !== SERVICE_REQUEST_TYPES_VALUES.International_Voice_Services  ? <hr className={styles.separatortop} />:<></>}
            {!ivcCustomerData?.oneITSMAccountServiceName&&props?.myRights?.userType===USER_TYPE.CUSTOMER&&ivcCustomerData.serviceType?.value===Incident_Service_Type_Values.IVC_Service?
            <OneITSMIndicator/>:<>
            <div className={styles.note}>Please Provide The Details</div>
          <TextField
                 placeholder="Enter here"
                 label="Title"
                 name="issue"
                 type="text"
                 tooltiprquired="true"
                 maxlength={`${values?.issue?.length}/100 characters`}
                 tooltiptxt={renderTooltipList(TOOLTIPS.TITLE)}
               />
                {/* <div className={styles.commentValidation}>{`${values?.issue?.length}/100 characters`}</div> */}
             <div className={styles.textarea}>
           <TextArea
             label={"Problem Statement"}
             id="ProblemStatement"
             name="problemStatement"
             placeholder="Enter the description"
            maxlength={`${values?.problemStatement?.length}/1000 characters`}
             tooltiprquired="true"
             tooltiptxt={renderTooltipList(TOOLTIPS.PROBLEM_STATEMENT)}
           />
           </div>
           {/* <div className={styles.commentValidation}>{`${values?.problemStatement?.length}/1000 characters`}</div> */}
                 <div className={styles.expandedField}>
                   <MultipleEmailInput
                     name="additionalEmails"
                     label={FromLabel.additional_Email}
                     isPreviewMode={props.isIncidentPreviewModeOn}
                     requestorEmail={props?.myRights?.email}
                     showTooltip={true}
                     isNote={true}
                     tooltipText={"Additional Emails"}
                   />
                 </div>
           <br />
           <ImageUpload
             name="files"
             value={values.files}
             setFieldValue={setFieldValue}
             optional={false}
              tooltiprquired="true"
              tooltiptxt="Supporting Attachments"
           />
           </>}
         </Form>
          <footer className={styles.footer}>
          <hr className={styles.separator} />
          <ButtonWrapper>
            <BackButton className={styles.backButton}
              style={styles.submitt}
              title={"Cancel"} 
              closePopup={props.onClose} 
            />
            <Submit
              id="saveButton"
              className={styles.saveButton}
              style={styles.submitivc}
              title={"Submit"}
              disabled={!dirty || !isValid}
              form="ivc_service_request"
              isSubmitting={isSubmit}
            />
          </ButtonWrapper>  
          </footer>  
          </>
       )}
     </Formik>
   
   )
   };
   

    const mapStateToProps = (state) => {
      return {
        myRights:state.myRights.myRights,
        incidentActiveTab:state.incidentTab.incidentActiveTab,
      };
    };
    
    const mapDispatchToProps = (dispatch) => {
      return {
        openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
          },
          addService: (payload) => {
            return dispatch(SubmitService(payload))
          },
          getServiceList: (next=null)=>{
            return dispatch(getServiceList(next))
        },
        setIncidentActiveTab: (tab) => {
          return dispatch(setIncidentActiveTab(tab))
        },
        showErrorPopup: (errorHeader,errormessage,isnote) => {
          return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
        },
        getModuleNotification: () => {
             return dispatch(getModuleNotification())
        },
    
      };
    };
    
    export default connect(mapStateToProps, mapDispatchToProps)(IVC);